import { useLocation } from "react-router-dom";
import { disablePageScroll, enablePageScroll } from "scroll-lock";

import { brainwave } from "../assets";
import { navigation } from "../constants";
import Button from "./Button";

import MenuSvg from "../assets/svg/MenuSvg";
import { HamburgerMenu } from "./design/Header";
import { useState, useEffect } from "react";
import { HashLink as Link } from 'react-router-hash-link';
import "../index1.css"


const Header = () => {
  const pathname = useLocation();
  const [openNavigation, setOpenNavigation] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  const toggleNavigation = () => {
    if (openNavigation) {
      setOpenNavigation(false);
      enablePageScroll();
    } else {
      setOpenNavigation(true);
      disablePageScroll();
    }
  };

  const handleClick = () => {
    if (!openNavigation) return;

    enablePageScroll();
    setOpenNavigation(false);
  };


  return (
    <div
      className={`relative top-0 left-0 w-full z-50  border-b border-n-6 lg:bg-n-14/90 lg:backdrop-blur-sm ${
        openNavigation ? "bg-n-14" : "bg-n-14/90 backdrop-blur-sm"
      }`}
    >
      <div className="flex items-center px-5 lg:px-7.5 xl:px-10 max-lg:py-4">
        <a  href="/">
        <img src={brainwave} width={250} height={60} alt="TaiPi" />
        </a>
      
        <nav
          className={`${
            openNavigation ? "flex " : "hidden"
          } fixed  left-0 right-0 bottom-0 opacity-[.98] bg-white lg:static lg:flex lg:ml-auto lg:bg-transparent top-[5rem]`}
        >
          <div className={`relative z-2 flex flex-col items-center justify-center m-auto lg:flex-row`}>
            {navigation.map((item) => {
    // Update the item.url if conditions are met

    return (
      <a
        href={item.url}
        key={item.id}
        onClick={handleClick}
        className={`block relative font-sora text-[24px] lg:text-base uppercase text-black transition-colors hover:text-n-4 ${
          item.onlyMobile ? "lg:hidden" : ""
        } px-6 py-6 md:py-7 lg:-mr-0.25 lg:font-semibold lg:leading-3 lg:hover:text-n-4 xl:px-5 lg:text-base lg:text-white`}
      >
        {item.title}
      </a>
    );
  })}
          </div>

          <HamburgerMenu />
        </nav>

        
        <div className="flex ml-auto">

        <Button
          className="lg:hidden"
          px="px-3"
          onClick={toggleNavigation}
        >
          <MenuSvg openNavigation={openNavigation} />
        </Button>
              </div>
      </div>
    </div>
  );
};

export default Header;
